import React from "react";

interface AddHabitButtonProps {
  onClick: () => void;
}

export const AddHabitButton: React.FC<AddHabitButtonProps> = ({
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      style={{
        backgroundColor: "transparent",
        border: "1px dashed #ccc",
        borderRadius: "16px",
        padding: "10px 14px",
        margin: "5px",
        cursor: "pointer",
        color: "#000",
        display: "flex",
        alignItems: "center",
        minWidth: "80px",
        justifyContent: "center"
      }}
    >
      +
    </button>
  );
};